import React from "react";
import {Radios} from "mui-rff";
import {ReactComponent as Icon} from "../../../../assets/images/check-box/checkbox.svg";
import {ReactComponent as IconCheckbox} from "../../../../assets/images/check-box/checkbox-active.svg";
import classnames from "classnames";
import {FormControlLabel, Radio} from "@mui/material";

/**
 * @param {boolean} form
 * @param {import("mui-rff").RadioData[] | import("mui-rff").RadioData} data
 * @param {string} className
 * @param {string} labelClassName only for non-form checkboxes
 * @param {import("mui-rff").CheckboxesProps & import("@mui/material").CheckboxProps} props
 * @param {boolean} isInHeaderLogin
 * @param {ReactNode | undefined} icon
 * @param {ReactNode | undefined} checkedIcon
 */
const MuiRadio = ({
                      form = false,
                      data,
                      className,
                      isInHeaderLogin,
                      labelClassName,
                      icon = undefined,
                      checkedIcon = undefined,
                      ...props
                  }) => {

    return (
        <>
            {
                form
                    ? <Radios
                        className={classnames(`radio`, className)}
                        icon={icon ?? <Icon/>}
                        checkedIcon={checkedIcon ?? <IconCheckbox/>}
                        data={data}
                        {...props}
                    />
                    : <FormControlLabel
                        label={data.label}
                        disabled={data.disabled}
                        checked={data.value ?? false}
                        className={labelClassName}
                        control={
                            <Radio
                                icon={<Icon/>}
                                checkedIcon={<IconCheckbox/>}
                                className={classnames('checkbox', className)}
                                disabled={data.disabled}
                                checked={data.value ?? false}
                                {...props}
                            />
                        }
                    />
            }
        </>
    );
}

export default MuiRadio;
